<template>
    <page :tabs="tabs" :busy="busy">
        <grid ref="grid" :columnDefs="columnDefs" :rowData="rowData" :isAutoWidth="true"> </grid>
    </page>
</template>

<script>
import api from '../../api';
import { HOSTED_FORM_RESERVATION_ENDPOINT } from '../../endpoints';
import { formatResponseError } from '../../utils/api';
import grid from '../generic/grid/grid.vue';
import page from '../generic/page/page.vue';
export default {
    components: { grid, page },
    data() {
        return {
            rowData: [],
            busy: false,
        };
    },
    computed: {
        tabs() {
            return [
                {
                    title: 'Hosted Form List',
                    route: '/app/hosted-form/list/',
                    active: this.$route.path === '/app/hosted-form/list/',
                },
                {
                    title: 'Requested Forms',
                    route: '/app/hosted-form/pending/',
                    active: this.$route.path === '/app/hosted-form/pending/',
                },
                {
                    title: 'Сompleted Forms',
                    route: '/app/hosted-form/completed/',
                    active: this.$route.path === '/app/hosted-form/completed/',
                },
            ];
        },
        columnDefs() {
            return [
                {
                    field: 'created',
                    type: 'dateTimeColumn',
                },
                {
                    field: 'meta_reservation',
                    headerName: 'Invoice#',
                    cellRenderer: ({ data }) => {
                        return `<a href="/app/reservation/edit/invoice/${data.meta_reservation}">${data.meta_reservation}</a>`;
                    },
                },
                {
                    field: 'property',
                    headerName: 'Property',
                },
                {
                    field: 'guest_name',
                    headerName: 'Guest Name',
                },
                {
                    field: 'guest_email',
                    headerName: 'Guest Email',
                    autoWidthExclude: true,
                },
                {
                    field: 'form_title',
                    headerName: 'Form',
                    cellRenderer: ({ data }) => {
                        return `<a href="/app/hosted-form/${data.hosted_form}/edit/">${data.form_title}</a>`;
                    },
                },
            ];
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.busy = true;
                const { data } = await api.get(HOSTED_FORM_RESERVATION_ENDPOINT() + 'pending/');
                this.rowData = data;
            } catch (error) {
                const { generic } = formatResponseError(error);
                this.errorToast({ text: generic || 'Could not fetch hosted forms' });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style>
</style>